import TransparentButtonStories from '@/trio-ui/TransparentButton';
import * as Styles from './TableOfContentSidebar.styles';

type ContentType = {
  name: string;
  id?: string;
  scrollTo?: () => void;
};

export type TableOfContentSidebarProps = {
  title?: string;
  buttonLabel?: string;
  tableOfContentOptions: ContentType[];
  onClickAddNew?: () => void;
};

export default function TableOfContentSidebar({
  onClickAddNew,
  title = 'Jump To',
  buttonLabel = '+ New Interview',
  tableOfContentOptions,
  ...props
}: TableOfContentSidebarProps): JSX.Element {
  return (
    <Styles.Aside {...props}>
      {title && <Styles.Title>{title}</Styles.Title>}
      <ul>
        {tableOfContentOptions.map((option) => {
          return (
            <li key={option?.id}>
              <Styles.Text
                type="button"
                onClick={() => {
                  if (option?.scrollTo) {
                    option?.scrollTo();
                  }
                }}
              >
                {option.name}
              </Styles.Text>
            </li>
          );
        })}
      </ul>
      {onClickAddNew && (
        <TransparentButtonStories onClick={onClickAddNew} isBlueButton>
          {buttonLabel}
        </TransparentButtonStories>
      )}
    </Styles.Aside>
  );
}
